<template>
  <!-- 导入模板 -->
  <el-dialog
    :title="`导入`"
    :visible.sync="visible"
    class="file-upload"
    center>
      <div style="text-align: center;">
        <el-upload
        class="upload-demo"
        drag
        action="#"
        :auto-upload="false"
        ref="fileUpload"
        >
        <i class="el-icon-upload"></i>
        <!-- 将文件拖到此处，或  点击上传-->
        <div class="el-upload__text">将文件拖到此处 <em>上传</em></div>
      </el-upload>
      <!--下载模板： 点击下载模板文件 -->
      <div v-if="link" class="mt10"><a :href="downloadLink" :download="fileName">下载模板</a></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 取 消 -->
        <el-button size="small" @click="visible = false">取消</el-button>
        <!-- 确 定 -->
        <el-button size="small" type="primary" @click="upload()">确定</el-button>
      </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'FileImport',
  props: {
    link: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: false
    }
  },
  computed: {
    fileName() {
      const linkArr = this.link.split('/')
      const item = linkArr.filter(i => i.includes('.xlsx'))[0] || null

      return item ? item.split('.')[0] : ''
    },
    downloadLink() {
      const env = process.env.NODE_ENV
      const { port } = window.location
      const url = env.includes('dev')  ? `https://121.4.142.15:${port}/cdn${this.link}` : `${window.location.origin}/cdn${this.link}`
      
      return url
    }
  },
  methods: {
    async upload() {
      // 开始上传
      const file = this.$refs.fileUpload.uploadFiles[0]
      if (!file) {
        // this.$message.error('请选择文件')
        this.$message.error(`请选择文件`)
        return
      }
      const item = {
        raw: file.raw,
        filename: file.name,
        size: file.size
      }
      const res = await this.$upload.start(item)
      if (res) {
        this.complete(res)
      }
    },
    complete(file) {
      this.$emit('complete', file)
      this.reset()
      this.visible = false
    },
    reset() {
      this.$refs.fileUpload.uploadFiles = []
    },
    show() {
      this.visible = true
    }
  }
}
</script>

<style lang="scss" scoped>
  .file-upload {
    /deep/ .el-dialog {
      width: 450px;
    }
    .span_required{
      color:red;
      font-size:18px;
    }
  }
</style>